import { Link } from 'react-router-dom';
import { InstagramIcon, WhatsAppIcon } from './SocialBrandIcons';

const SOCIALS = [
  { label: 'Instagram', href: 'https://instagram.com/richard_atik', Icon: InstagramIcon },
  { label: 'WhatsApp', href: 'https://wa.me/34670784860', Icon: WhatsAppIcon }
];

const SiteFooter = ({ imgBase }) => (
  <footer className="border-t border-slate-100 bg-white py-20">
    <div className="container mx-auto px-6">
      <div className="mb-16 grid gap-12 md:grid-cols-3">
        <div className="space-y-6">
          <Link to="/">
            <img src={`${imgBase}logo_banner.png`} alt="Richard Atik" className="h-12 object-contain" />
          </Link>
          <p className="max-w-xs text-xs font-bold uppercase tracking-widest leading-relaxed text-slate-500">
            Centro multidisciplinar orientado al equilibrio sistémico.
          </p>
          <p>
            <Link
              to="/artes-marciales"
              className="text-[10px] font-bold uppercase tracking-widest text-emerald-700 hover:underline"
            >
              Unryukai Budo Taijutsu, linaje y actividades
            </Link>
          </p>
        </div>
        <div>
          <h4 className="mb-6 text-[10px] font-bold uppercase tracking-[0.3em] text-slate-400">
            Ubicación
          </h4>
          <p className="text-sm font-bold text-slate-900">C/ Aguadulce, 22</p>
          <p className="text-sm text-slate-500">35004, Las Palmas de G.C.</p>
        </div>
        <div>
          <h4 className="mb-6 text-[10px] font-bold uppercase tracking-[0.3em] text-slate-400">
            Canales
          </h4>
          <div className="flex flex-wrap gap-4">
            {SOCIALS.map(({ label, href, Icon }) => (
              <a
                key={label}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 rounded-lg bg-slate-50 px-4 py-2 text-[10px] font-bold uppercase tracking-widest transition-all hover:bg-slate-900 hover:text-white"
              >
                <Icon className="h-4 w-4 shrink-0" />
                {label}
              </a>
            ))}
          </div>
        </div>
      </div>
      <div className="flex flex-col items-center justify-between gap-4 border-t border-slate-50 pt-8 text-[10px] font-bold uppercase tracking-widest text-slate-400 md:flex-row">
        <p>© 2026 Richard Atik. Todos los derechos reservados.</p>
      </div>
    </div>
  </footer>
);

export default SiteFooter;
